import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import ReferencialAction from '../../../action/ReferencialAction'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_TAXON,
    PATH_REFERENCIAL_TAXON_LINK,
    PATH_REFERENCIAL_TAXON_NEW,
} from '../../../../home/constants/RouteConstants'
import TaxonDto from '../dto/TaxonDto'
import TaxonAction from '../actions/TaxonAction'
import QualityAction from '../../../../quality/actions/QualityAction'
import HomeAction from 'home/actions/HomeAction'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import Checkbox from '../../../../components/forms/Checkbox'
import useSandreList from 'utils/customHook/useSandreList'
import { getUser } from 'utils/SettingUtils'
import ToastrAction from 'toastr/actions/ToastrAction'
import { push } from '@lagunovsky/redux-react-router'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import sandre from 'assets/pictures/logos/sandre.png'
import inpn from 'assets/pictures/logos/inpn.png'
import { inpnTaxonLink, sandreTaxonLink } from 'conf/SieauConstants'
import ApplicationConf from 'conf/ApplicationConf'
import { useParams } from 'react-router'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import useBoolean from 'utils/customHook/useBoolean'
import { Box, Card, CardContent, Grid2 } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import MUIReplaceDialog from 'referencial/components/MUIReplaceDialog'
import ConfirmModal from 'components/modal/ConfirmModal'

const TaxonApp = () => {
    const { code } = useParams()
    const {
        taxonProps,
        taxons,
        sandreCodes,
        qualitometers,
        referencialStatus,
        checkDelete,
    } = useSelector(store => ({
        taxonProps: store.TaxonReducer.taxon,
        taxons: store.TaxonReducer.taxons,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        qualitometers: store.QualityReducer.qualitometersLight,
        referencialStatus: store.ReferencialReducer.referencialStatus,
        checkDelete: store.ReferencialReducer.checkDelete,
    }), shallowEqual)

    const dispatch = useDispatch()

    const { value: isDeleteOpen, setTrue: onOpenDelete, setFalse: onCloseDelete } = useBoolean(false)

    const [taxon, setTaxon] = useState(new TaxonDto({}))
    const [themes, setThemes] = useState([])
    const [levels, setLevels] = useState([])
    const [isEditMode, setIsEditMode] = useState(code === 'new')
    const [openReplace, setOpenReplace] = useState(false)

    const sandreThemes = useSandreList(SANDRE.TAXONS_THEME)
    const sandreLevels = useSandreList(SANDRE.TAXONS_NIVEAUX)

    const setSandreCodeToState = useCallback(() => {
        setThemes(sandreThemes)
        setLevels(sandreLevels)
    }, [sandreLevels, sandreThemes])

    const isConsultant = useMemo(() => getUser().consultant === '1', [])

    const getTaxonLinks = () => {
        return [
            taxonProps.refmuseum && {
                href: inpnTaxonLink + taxonProps.refmuseum,
                img: inpn,
                label: i18n.inpn.toUpperCase(),
            },
            taxonProps.code && {
                href: sandreTaxonLink + taxonProps.code,
                img: sandre,
                label: i18n.sandre.toUpperCase(),
            },
        ].filter(l => !!l)
    }

    useEffect(() => {
        return () => dispatch(TaxonAction.reset())
    }, [dispatch])

    useActions(() => {
        if (isConsultant) {
            return {}
        }
        const links = getTaxonLinks()
        const isNewActions = code === 'new' && !taxonProps.code
        const actions = (() => {
            if (isNewActions) {
                return {
                    save: () => {
                        const existCode = taxons.some(f => f.code === taxon.code)
                        if (existCode) {
                            dispatch(ToastrAction.error(i18n.codeAlreadyExists))
                        } else if (!taxon.code) {
                            dispatch(ToastrAction.error(i18n.thanksToEnterCode))
                        } else {
                            dispatch(TaxonAction.createTaxon(taxon))
                            setIsEditMode(false)
                        }
                    },
                    cancel: () => {
                        dispatch(push(PATH_REFERENCIAL_TAXON))
                        setIsEditMode(false)
                    },
                }
            }
            if (isEditMode) {
                return {
                    save: () => {
                        dispatch(TaxonAction.updateTaxon(taxon))
                        setIsEditMode(false)
                    },
                    cancel: () => {
                        setTaxon(taxonProps)
                        setIsEditMode(false)
                    },
                }
            }
            return {
                edit: () => {
                    setIsEditMode(true)
                },
                replace: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.taxonCountDelete(code)))
                    setOpenReplace(true)
                },
                deleteCheck: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.taxonCountDelete(code)))
                    onOpenDelete()
                },
            }
        })()
        return (!isNewActions && !isEditMode && links.length > 0) ? { ...actions, links } : actions
    }, [isConsultant, code, taxonProps, taxon, isEditMode])

    useTitle(() => {
        if (code === 'new') {
            return [
                {
                    title: i18n.referencials,
                    href: PATH_REFERENCIAL,
                },
                {
                    title: i18n.taxons,
                    href: PATH_REFERENCIAL_TAXON,
                },
                {
                    title: i18n.new,
                    href: PATH_REFERENCIAL_TAXON_NEW,
                },
            ]
        }
        return [
            {
                title: i18n.referencials,
                href: PATH_REFERENCIAL,
            },
            {
                title: i18n.taxons,
                href: PATH_REFERENCIAL_TAXON,
            },
            {
                title: code + (taxonProps.latinName ? ` - ${taxonProps.latinName}` : ''),
                href: PATH_REFERENCIAL_TAXON_LINK + code,
            },
        ]
    }, [code, taxonProps])

    useEffect(() => {
        dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.taxonCountDelete(code)))
        if (code !== 'new') {
            dispatch(TaxonAction.fetchTaxon(code)).then(newTaxon => setTaxon(newTaxon))
            setIsEditMode(false)
        } else {
            setIsEditMode(true)
        }

        if (!qualitometers.length) {
            dispatch(QualityAction.fetchQualitometers())
        }

        if (!referencialStatus.length) {
            dispatch(ReferencialAction.fetchReferencialStatus())
        }

        if (!sandreCodes.length) {
            dispatch(ReferencialAction.fetchSandreCodes()).then(setSandreCodeToState)
        } else {
            setSandreCodeToState()
        }
        if (!taxons.length) {
            dispatch(TaxonAction.fetchTaxons())
        }

        dispatch(HomeAction.setHelpLink('', ''))
    }, [code])

    return (
        <Box margin='10px 10px 10px 0'>
            <Card>
                <CardTitle title={i18n.description}/>
                <CardContent>
                    <Grid2 container spacing={1}>
                        <Grid2 size={12}>
                            <Select
                                options={themes}
                                label={i18n.theme}
                                value={parseInt(taxon.theme)}
                                onChange={theme => setTaxon({ ...taxon, theme })}
                                nullLabel='&nbsp;'
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.code}
                                value={taxon.code}
                                onChange={newCode => setTaxon({ ...taxon, code: newCode })}
                                disabled={!isEditMode}
                                maxLength={6}
                                obligatory
                            />

                        </Grid2>
                        <Grid2 size={4}>
                            <Select
                                options={referencialStatus}
                                label={i18n.status}
                                value={parseInt(taxon.status)}
                                onChange={v => setTaxon({ ...taxon, status: v?.toString() })}
                                nullLabel='&nbsp;'
                                disabled={!isEditMode}
                            />

                        </Grid2>
                        <Grid2 size={4} marginTop='15px'>
                            <Checkbox
                                checked={taxon.active === '1'}
                                onChange={v => setTaxon({ ...taxon, active: v ? '1' : '0' })}
                                label={i18n.active}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Input
                                title={i18n.latinName}
                                value={taxon.latinName}
                                onChange={latinName => setTaxon({ ...taxon, latinName })}
                                disabled={!isEditMode}
                            />

                        </Grid2>
                        <Grid2 size={12}>
                            <Input
                                title={i18n.name}
                                value={taxon.name}
                                onChange={name => setTaxon({ ...taxon, name })}
                                disabled={!isEditMode}
                            />

                        </Grid2>
                        <Grid2 size={12}>
                            <Textarea
                                title={i18n.comment}
                                value={taxon.comment}
                                onChange={comment => setTaxon({ ...taxon, comment })}
                                disabled={!isEditMode}
                            />

                        </Grid2>
                        <Grid2 size={12}>
                            <Textarea
                                title={i18n.bibliography}
                                value={taxon.bibliographicReference}
                                onChange={bibliographicReference => setTaxon({ ...taxon, bibliographicReference })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Input
                                title={i18n.author}
                                value={taxon.author}
                                onChange={author => setTaxon({ ...taxon, author })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Input
                                title={i18n.writter}
                                value={taxon.writter}
                                onChange={writter => setTaxon({ ...taxon, writter })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <SimpleDatePicker
                                onChange={creationDate => setTaxon({ ...taxon, creationDate })}
                                label={ i18n.creationDate }
                                value={ taxon.creationDate }
                                max={ taxon.updateDate }
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <SimpleDatePicker
                                onChange={updateDate => setTaxon({ ...taxon, updateDate })}
                                label={ i18n.modificationDate }
                                value={ taxon.updateDate }
                                max={ taxon.creationDate }
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Select
                                className={'padding-top-5-px'}
                                options={taxons}
                                label={i18n.elementOf}
                                value={parseInt(taxon.elementOf)}
                                onChange={elementOf => setTaxon({ ...taxon, elementOf })}
                                nullLabel='&nbsp;'
                                disabled={!isEditMode}
                                clearFunction
                                keyValue='code'
                                keyLabel='labelWithCode'
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Select
                                options={levels}
                                label={i18n.level}
                                value={parseInt(taxon.level)}
                                onChange={level => setTaxon({ ...taxon, level })}
                                nullLabel='&nbsp;'
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.omnidiaCode}
                                value={taxon.omnidiaCode}
                                onChange={omnidiaCode => setTaxon({ ...taxon, omnidiaCode })}
                                disabled={!isEditMode}
                                maxLength={6}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.naturalHistoryMuseum}
                                value={taxon.refmuseum}
                                onChange={refmuseum => setTaxon({ ...taxon, refmuseum })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.macrophyte}
                                value={taxon.macrophyteCode}
                                onChange={macrophyteCode => setTaxon({ ...taxon, macrophyteCode })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.spomnidia}
                                value={taxon.spomnidia}
                                onChange={spomnidia => setTaxon({ ...taxon, spomnidia })}
                                disabled={!isEditMode}
                                maxLength={6}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.aspe}
                                value={taxon.aspe}
                                onChange={aspe => setTaxon({ ...taxon, aspe })}
                                disabled={!isEditMode}
                                maxLength={20}
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Input
                                title={i18n.worms}
                                value={taxon.worms}
                                onChange={worms => setTaxon({ ...taxon, worms })}
                                disabled={!isEditMode}
                                maxLength={20}
                            />
                        </Grid2>
                        <Grid2 size='auto'>
                            <Checkbox
                                label={i18n.calculatedTaxon}
                                checked={taxon.calculate === '1'}
                                onChange={(e) => setTaxon({ ...taxon, calculate: e ? '1' : '0' })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <Textarea
                                title={i18n.calculatedTaxons}
                                value={taxon.calculTaxonCode}
                                onChange={calculTaxonCode => setTaxon({ ...taxon, calculTaxonCode })}
                                disabled={!isEditMode}
                            />
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Card>
            <MUIReplaceDialog
                elements={taxons}
                title={`${i18n.taxon} [${taxon.code}]`}
                label={i18n.taxon}
                keyLabel='latinName'
                onValidate={(newCode) => dispatch(TaxonAction.replaceTaxon(taxon.code, newCode.code))}
                open={openReplace}
                onClose={() => setOpenReplace(false)}
            />
            <ConfirmModal
                isOpen={isDeleteOpen}
                title={i18n.deletingConfirmation}
                subTitle={`${i18n.numberOfUse}${checkDelete}`}
                disabled={checkDelete !== 0}
                onValidate={() => {
                    dispatch(TaxonAction.deleteTaxon(taxon.code)).then(res => {
                        if (res.value > 0) {
                            onCloseDelete()
                            dispatch(TaxonAction.fetchTaxons())
                            dispatch(push('/referencial/taxon'))
                        }
                    })
                }}
                onClose={onCloseDelete}
            />
        </Box>
    )
}

export default TaxonApp
